<script setup lang="ts">
// TODO: Fix viewBox placement on large screens
</script>

<template>
  <svg viewBox="0 0 1148 387" preserveAspectRatio="xMinYMin meet" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient
        id="base_main_oval_gradient"
        gradientUnits="objectBoundingBox"
        cx="50%"
        cy="50%"
        fx="50%"
        fy="50%"
        r="46%"
        gradientTransform="translate(0.5,0.5),rotate(90),translate(-0.5,-0.5)"
      >
        <stop offset="0%" stop-color="currentColor" />
        <stop offset="100%" stop-color="#091524" />
      </radialGradient>
    </defs>
    <path
      id="Oval"
      d="M574 387C891.011 387 1148 130.011 1148 -187C1148 -504.011 891.011 -761 574 -761C256.989 -761 0 -504.011 0 -187C0 130.011 256.989 387 574 387Z"
      fill="url(#base_main_oval_gradient)"
      fill-opacity="0.584"
      fill-rule="evenodd"
      stroke="none"
    >
      <animate attributeName="fill-opacity" values="0.4;1;0.4" dur="5s" repeatCount="indefinite" />
    </path>
  </svg>
</template>
